export class CurrencyType {

  static readonly US_DOLLAR = new CurrencyType("$");
  static readonly SG_DOLLAR = new CurrencyType("S$");
  static readonly IN_RUPEE = new CurrencyType("₹");

  private constructor(readonly prefix: string) {
  }

  getValue(n: number): number {
    return ((n || 0) / 100);
  }

  getText(n: number): string {
    return `${this.prefix} ${((n || 0) / 100).toFixed(2)}`;
  }
}
